import { toFileReadError } from '@/utils/file';

export const toDataUrl = async (file: File): Promise<string | null> => {
  try {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (!reader.result) {
          return resolve(null);
        }
        if (typeof reader.result === 'string') {
          return resolve(reader.result);
        }

        reject(new Error('Unable to process File upload'));
      };
      reader.onerror = () => reject(toFileReadError(reader));
      reader.readAsDataURL(file);
    });
  } catch (err) {
    return null;
  }
};

type ObjectUrlToFileOptions = {
  filename: string;
};

export const objectUrlToFile = async (
  url: string,
  { filename }: ObjectUrlToFileOptions
): Promise<File> => {
  const response = await fetch(url);
  const blob = await response.blob();

  const mime = blob.type || 'application/octet-stream';

  return new File([blob], filename, { type: mime });
};
